import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const MoonCalendarLegend: React.FC = () => {
  return (
    <Card className="glass-card border-border/50 shadow-lg">
      <CardHeader>
        <CardTitle className="text-foreground font-light text-xl">Moon Photography Glossary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground leading-relaxed">
        <div>• <strong className="text-foreground">Azimuth:</strong> The compass direction where the moon rises or sets (e.g., "ENE 72°" means East-Northeast at 72 degrees from North)</div>
        <div>• <strong className="text-foreground">Max Altitude:</strong> The highest point the moon reaches in the sky, measured in degrees above the horizon (90° = directly overhead)</div>
        <div>• <strong className="text-foreground">Supermoon:</strong> A full moon occurring near lunar perigee (closest approach to Earth), appearing ~14% larger and ~30% brighter than average</div>
        <div>• <strong className="text-foreground">Golden Hour:</strong> The period shortly after sunrise or before sunset when warm, soft light is ideal for photography</div>
        <div>• <strong className="text-foreground">Blue Hour:</strong> The twilight period before sunrise or after sunset when the sky takes on a deep blue hue - perfect for moon silhouettes</div>
        <div>• <strong className="text-foreground">Illumination %:</strong> The percentage of the moon's visible surface lit by the sun (100% = full moon)</div>
      </CardContent>
    </Card>
  );
};
